import { Flex } from "@jsq/ds/core";
import React from "react";
import Layout from "apps/portal/Portal/common/authentication/Layout";
import { type UnauthenticatedArenaObjectType } from "apps/portal/Portal/common/types";
import { type Maybe } from "graphql/jsutils/Maybe";
import styles from "./styles.scss";

type Props = {
  splitScreen?: boolean;
  arena?: UnauthenticatedArenaObjectType;
  photoUrl?: Maybe<string>;
  showArenaNameInFooter?: boolean;
  showJSQLogo?: boolean;
};

export const LoginLayout: React.FunctionComponent<Props> = (props) => {
  const { splitScreen, arena, photoUrl, showArenaNameInFooter, showJSQLogo } = props;
  return (
    <Flex
      flexGrow={1}
      data-testid="login-container"
      className={styles.LoginLayout__heightAndColor}
    >
      <Flex
        flexGrow={1}
        flexBasis="45%"
        flexDirection="column"
        className={styles.LoginLayout__scrollContainer}
      >
        <Layout
          arena={arena}
          splitScreen={splitScreen}
          showArenaNameInFooter={showArenaNameInFooter}
          showJSQLogo={showJSQLogo}
        >
          {props.children}
        </Layout>
      </Flex>
      {splitScreen && (
        <div
          className={styles.LoginPage__photo}
          style={{ backgroundImage: `url(${photoUrl})` }}
        />
      )}
    </Flex>
  );
};
